import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    pageLayout: {
        display: "flex",
        flexDirection: "row",
        gap: theme.spacing(2),
        flex: 1,
        minHeight: 0,
    },
    mainContent: {
        flex: "4 1 0",
        minWidth: 0,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
    },
}));
